import { Alert, Box, Button, Typography, useTheme } from '@mui/material';

import { ActionCardDefinition } from './ActionCardDefinitions';

interface BoxWrapperProps {
  children: React.ReactNode;
}

function StartApplicationActionCard({
  headerText,
  buttonText,
  buttonDisabled,
  labelText,
  onClick,
}: ActionCardDefinition) {
  return (
    <BoxWrapper>
      <Typography
        variant='h4'
        sx={{
          m: 0,
          textAlign: 'center',
          fontSize: { xs: '1rem', sm: '1.25rem' },
          lineHeight: 1.25,
          overflowWrap: 'anywhere',
        }}
      >
        {headerText}
      </Typography>
      <Button
        variant='primary'
        size='large'
        onClick={onClick}
        disabled={buttonDisabled}
        sx={{ width: { xs: '100%', sm: 'auto' } }}
      >
        {buttonText}
      </Button>
      {labelText != null && labelText !== '' && (
        <Alert severity='info' sx={{ maxWidth: '100%', width: '100%' }}>
          {labelText}
        </Alert>
      )}
    </BoxWrapper>
  );
}

function BoxWrapper({ children }: BoxWrapperProps) {
  const theme = useTheme();

  return (
    <Box
      justifyContent='center'
      alignItems='center'
      display='flex'
      flexDirection='column'
      padding={{ xs: 2, sm: 4 }}
      gap={{ xs: '14px', sm: '24px' }}
      sx={{
        backgroundColor: theme.palette.sandShade1.main,
        width: '100%',
        alignSelf: 'stretch',
        flex: { xs: '1 1 100%', md: '1 1 500px' },
        maxWidth: { xs: '100%', md: 'min(780px, calc(100vw - 40px))' },
        minWidth: 0,
      }}
    >
      {children}
    </Box>
  );
}

export default StartApplicationActionCard;
